export const colors = {
  aliceblue: 'aliceblue',
  antiquewhite: 'antiquewhite',
  aqua: 'aqua',
  aquamarine: 'aquamarine',
  azure: 'azure',
  beige: 'beige',
  bisque: 'bisque',
  black: 'black',
  blanchedalmond: 'blanchedalmond',
  blue: 'blue',
  blueviolet: 'blueviolet',
  brown: 'brown',
  burlywood: 'burlywood',
  cadetblue: 'cadetblue',
  chartreuse: 'chartreuse',
  chocolate: 'chocolate',
  coral: 'coral',
  cornflowerblue: 'cornflowerblue',
  cornsilk: 'cornsilk',
  crimson: 'crimson',
  cyan: 'cyan',
  darkblue: 'darkblue',
  darkcyan: 'darkcyan',
  darkgoldenrod: 'darkgoldenrod',
  darkgray: 'darkgray',
  darkgreen: 'darkgreen',
  darkgrey: 'darkgrey',
  darkkhaki: 'darkkhaki',
  darkmagenta: 'darkmagenta',
  darkolivegreen: 'darkolivegreen',
  darkorange: 'darkorange',
  darkorchid: 'darkorchid',
  darkred: 'darkred',
  darksalmon: 'darksalmon',
  darkseagreen: 'darkseagreen',
  darkslateblue: 'darkslateblue',
  darkslategray: 'darkslategray',
  darkslategrey: 'darkslategrey',
  darkturquoise: 'darkturquoise',
  darkviolet: 'darkviolet',
  deeppink: 'deeppink',
  deepskyblue: 'deepskyblue',
  dimgray: 'dimgray',
  dimgrey: 'dimgrey',
  dodgerblue: 'dodgerblue',
  firebrick: 'firebrick',
  floralwhite: 'floralwhite',
  forestgreen: 'forestgreen',
  fuchsia: 'fuchsia',
  gainsboro: 'gainsboro',
  ghostwhite: 'ghostwhite',
  gold: 'gold',
  goldenrod: 'goldenrod',
  gray: 'gray',
  green: 'green',
  greenyellow: 'greenyellow',
  grey: 'grey',
  honeydew: 'honeydew',
  hotpink: 'hotpink',
  indianred: 'indianred',
  indigo: 'indigo',
  ivory: 'ivory',
  khaki: 'khaki',
  lavender: 'lavender',
  lavenderblush: 'lavenderblush',
  lawngreen: 'lawngreen',
  lemonchiffon: 'lemonchiffon',
  lightblue: 'lightblue',
  lightcoral: 'lightcoral',
  lightcyan: 'lightcyan',
  lightgoldenrodyellow: 'lightgoldenrodyellow',
  lightgray: 'lightgray',
  lightgreen: 'lightgreen',
  lightgrey: 'lightgrey',
  lightpink: 'lightpink',
  lightsalmon: 'lightsalmon',
  lightseagreen: 'lightseagreen',
  lightskyblue: 'lightskyblue',
  lightslategray: 'lightslategray',
  lightslategrey: 'lightslategrey',
  lightsteelblue: 'lightsteelblue',
  lightyellow: 'lightyellow',
  lime: 'lime',
  limegreen: 'limegreen',
  linen: 'linen',
  magenta: 'magenta',
  maroon: 'maroon',
  mediumaquamarine: 'mediumaquamarine',
  mediumblue: 'mediumblue',
  mediumorchid: 'mediumorchid',
  mediumpurple: 'mediumpurple',
  mediumseagreen: 'mediumseagreen',
  mediumslateblue: 'mediumslateblue',
  mediumspringgreen: 'mediumspringgreen',
  mediumturquoise: 'mediumturquoise',
  mediumvioletred: 'mediumvioletred',
  midnightblue: 'midnightblue',
  mintcream: 'mintcream',
  mistyrose: 'mistyrose',
  moccasin: 'moccasin',
  navajowhite: 'navajowhite',
  navy: 'navy',
  oldlace: 'oldlace',
  olive: 'olive',
  olivedrab: 'olivedrab',
  orange: 'orange',
  orangered: 'orangered',
  orchid: 'orchid',
  palegoldenrod: 'palegoldenrod',
  palegreen: 'palegreen',
  paleturquoise: 'paleturquoise',
  palevioletred: 'palevioletred',
  papayawhip: 'papayawhip',
  peachpuff: 'peachpuff',
  peru: 'peru',
  pink: 'pink',
  plum: 'plum',
  powderblue: 'powderblue',
  purple: 'purple',
  red: 'red',
  rosybrown: 'rosybrown',
  royalblue: 'royalblue',
  saddlebrown: 'saddlebrown',
  salmon: 'salmon',
  sandybrown: 'sandybrown',
  seagreen: 'seagreen',
  seashell: 'seashell',
  sienna: 'sienna',
  silver: 'silver',
  skyblue: 'skyblue',
  slateblue: 'slateblue',
  slategray: 'slategray',
  slategrey: 'slategrey',
  snow: 'snow',
  springgreen: 'springgreen',
  steelblue: 'steelblue',
  tan: 'tan',
  teal: 'teal',
  thistle: 'thistle',
  tomato: 'tomato',
  turquoise: 'turquoise',
  violet: 'violet',
  wheat: 'wheat',
  white: 'white',
  whitesmoke: 'whitesmoke',
  yellow: 'yellow',
  yellowgreen: 'yellowgreen'
};
//# sourceMappingURL=colors.js.map